import { useQuery } from "@tanstack/react-query";
import useAPI from "./useAPI";

const useStaticIPs = () => {
  const { getPlatformStaticIPs } = useAPI();

  const staticIPsQuery = useQuery({
    queryKey: ["platformStaticIPs"],
    queryFn: getPlatformStaticIPs,
    select: (response) => response.data,
  });

  return {
    staticIPs: staticIPsQuery.data || [],
    isLoading: staticIPsQuery.isLoading,
    isError: staticIPsQuery.isError,
  };
};

export default useStaticIPs;
